export default "__VITE_ASSET__DNuprxpX__"